import { render } from "./OpenListInNewWindowButton.vue?vue&type=template&id=33dcf7bd&scoped=true"
import script from "./OpenListInNewWindowButton.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./OpenListInNewWindowButton.vue?vue&type=script&charset=utf-8&lang=js"

import "./OpenListInNewWindowButton.vue?vue&type=style&index=0&id=33dcf7bd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dcf7bd"]])

export default __exports__